import React from 'react';
import {Avatar, ListItem, makeStyles} from '@rneui/themed';
import {Card} from '@rneui/themed';

import Text from '../../themed/Text';

type Props = {
  testID?: string;
  notes?: string;
  onPress: () => void;
};

function OrderNotes({testID, notes, onPress}: Props) {
  const styles = useStyles();
  return (
    <>
      <ListItem testID={testID} onPress={onPress}>
        <Avatar
          icon={{
            type: 'material-design',
            name: 'text',
            size: 24,
            color: 'black',
          }}
        />
        <ListItem.Content>
          <ListItem.Subtitle>Order notes</ListItem.Subtitle>
          <ListItem.Title>
            <Text variant="body2">{notes}</Text>
          </ListItem.Title>
        </ListItem.Content>
        <ListItem.Chevron size={24} color={styles.text.color} />
      </ListItem>
      <Card.Divider />
    </>
  );
}

const useStyles = makeStyles(theme => {
  return {
    text: {
      color: theme.colors?.legacy?.text?.heading?.primary,
    },
  };
});

export default OrderNotes;
